module.exports = __webpack_public_path__ + "a11ca2aeef37d7ea2afc2bb0ee8d3a33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Cave_S.jpg
// module id = 31
// module chunks = 0